var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cls},[_c('input',{attrs:{"type":"radio","id":_vm.labelId},domProps:{"checked":_vm.checked,"value":_vm.valNm},on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('label',{attrs:{"for":_vm.labelId}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }